<template>
  <cube-scroll class="um-scroll" :ref="ulHandleKey"
               :options="scrollOption"
               @before-scroll-start="onStartScroll"
               @scroll-end="onScrollEnd"
               @pulling-down="onLoadNew"
               @pulling-up="onLoadMore">
    <template>
      <slot name="loading" class="loading" v-if="ulShowLoading">
        <empty-place :ulType=2 :ul-text="ulLoadingText"></empty-place>
      </slot>
    </template>
    <template>
      <slot name="empty" class="empty" v-if="ulShowEmpty">
        <empty-place :ul-text="ulEmptyText"></empty-place>
      </slot>
    </template>
    <template>
      <slot v-if="showErr" name="error" class="error">
        <div>error</div>
      </slot>
    </template>
    <template>
      <slot name="content" class="content">

      </slot>
    </template>
  </cube-scroll>
</template>

<script type="text/ecmascript-6">
  import EmptyPlace from 'common/components/universal/emptyPlacehold/emptyPlacehold'
  import Vue from 'vue'
  import BScroll from 'better-scroll'

  export default {
    data () {
      return {
        showEmpty: this.ulShowEmpty,
        showLoading: this.ulShowLoading,
        showErr: this.ulShowErr
      }
    },
    created () {
    },
    activated () {
      this.rebuildScroll()
    },
    mounted () {
      /* eslint-disable */
      var TOUCH_EVENT = 1
      var MOUSE_EVENT = 2

      var eventType = {
        touchstart: TOUCH_EVENT,
        touchmove: TOUCH_EVENT,
        touchend: TOUCH_EVENT,

        mousedown: MOUSE_EVENT,
        mousemove: MOUSE_EVENT,
        mouseup: MOUSE_EVENT
      }
      var DIRECTION_UP = 1
      var DIRECTION_DOWN = -1
      var DIRECTION_LEFT = 1
      var DIRECTION_RIGHT = -1

      var PROBE_DEBOUNCE = 1

      var PROBE_REALTIME = 3

      function getNow() {
        return window.performance && window.performance.now ? window.performance.now() + window.performance.timing.navigationStart : +new Date();
      }

      function preventDefaultException(el, exceptions) {
        for (var i in exceptions) {
          if (exceptions[i].test(el[i])) {
            return true;
          }
        }
        return false;
      }
      BScroll.prototype._move = function (e) {
        if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
          return
        }
        if (this.options.preventDefault && !preventDefaultException(e.target, this.options.preventDefaultException)) {
          e.preventDefault()
        }
        if (this.options.stopPropagation) {
          e.stopPropagation()
        }

        var point = e.touches ? e.touches[0] : e
        var deltaX = point.pageX - this.pointX
        var deltaY = point.pageY - this.pointY

        this.pointX = point.pageX
        this.pointY = point.pageY

        this.distX += deltaX
        this.distY += deltaY

        var absDistX = Math.abs(this.distX)
        var absDistY = Math.abs(this.distY)

        var timestamp = getNow()

        // We need to move at least momentumLimitDistance pixels for the scrolling to initiate
        if (timestamp - this.endTime > this.options.momentumLimitTime && absDistY < this.options.momentumLimitDistance && absDistX < this.options.momentumLimitDistance) {
          return
        }

        // If you are scrolling in one direction lock the other
        if (!this.directionLocked && !this.options.freeScroll) {
          if (absDistX > absDistY + this.options.directionLockThreshold) {
            this.directionLocked = 'h' // lock horizontally
          } else if (absDistY >= absDistX + this.options.directionLockThreshold) {
            this.directionLocked = 'v' // lock vertically
          } else {
            this.directionLocked = 'n' // no lock
          }
        }

        if (this.directionLocked === 'h') {
          if (this.options.eventPassthrough === 'vertical') {
            e.preventDefault()
          } else if (this.options.eventPassthrough === 'horizontal') {
            this.initiated = false
            return
          }
          deltaY = 0
        } else if (this.directionLocked === 'v') {
          if (this.options.eventPassthrough === 'horizontal') {
            e.preventDefault()
          } else if (this.options.eventPassthrough === 'vertical') {
            this.initiated = false
            return
          }
          deltaX = 0
        }

        deltaX = this.hasHorizontalScroll ? deltaX : 0
        deltaY = this.hasVerticalScroll ? deltaY : 0
        this.movingDirectionX = deltaX > 0 ? DIRECTION_RIGHT : deltaX < 0 ? DIRECTION_LEFT : 0
        this.movingDirectionY = deltaY > 0 ? DIRECTION_DOWN : deltaY < 0 ? DIRECTION_UP : 0

        var newX = this.x + deltaX
        var newY = this.y + deltaY

        // Slow down or stop if outside of the boundaries
        var _options$bounce = this.options.bounce,
          _options$bounce$top = _options$bounce.top,
          top = _options$bounce$top === undefined ? true : _options$bounce$top,
          _options$bounce$botto = _options$bounce.bottom,
          bottom = _options$bounce$botto === undefined ? true : _options$bounce$botto,
          _options$bounce$left = _options$bounce.left,
          left = _options$bounce$left === undefined ? true : _options$bounce$left,
          _options$bounce$right = _options$bounce.right,
          right = _options$bounce$right === undefined ? true : _options$bounce$right

        if (newX > 0 || newX < this.maxScrollX) {
          if (newX > 0 && left || newX < this.maxScrollX && right) {
            newX = this.x + deltaX / 3
          } else {
            newX = newX > 0 ? 0 : this.maxScrollX
          }
        }
        if (newY > 0 || newY < this.maxScrollY) {
          if (newY > 0 && top || newY < this.maxScrollY && bottom) {
            newY = this.y + deltaY / 3
          } else {
            newY = newY > 0 ? 0 : this.maxScrollY
          }
        }

        if (!this.moved) {
          this.moved = true
          this.trigger('scrollStart')
        }

        this._translate(newX, newY)

        if (timestamp - this.startTime > this.options.momentumLimitTime) {
          this.startTime = timestamp
          this.startX = this.x
          this.startY = this.y

          if (this.options.probeType === PROBE_DEBOUNCE) {
            this.trigger('scroll', {
              x: this.x,
              y: this.y
            })
          }
        }

        if (this.options.probeType > PROBE_DEBOUNCE) {
          this.trigger('scroll', {
            x: this.x,
            y: this.y
          })
        }

        var scrollLeft = document.documentElement.scrollLeft || window.pageXOffset || document.body.scrollLeft
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop

        var pX = this.pointX - scrollLeft
        var pY = this.pointY - scrollTop

        if (pX > document.documentElement.clientWidth - this.options.momentumLimitDistance || pX < this.options.momentumLimitDistance || pY < this.options.momentumLimitDistance || pY > document.documentElement.clientHeight - this.options.momentumLimitDistance) {
          this._end(e)
        }
      }
      /* eslint-enable */
    },
    props: {
      ulHandleKey: {
        type: String,
        required: true
      },
//       是否显示进度条淡入淡出效果
      ulScrollbar: {
        type: Boolean,
        default: true
      },
//      是否显示进度条，默认不显示
      ulShowScrollBar: {
        type: Boolean,
        default: false
      },
//      是否显示加载中
      ulShowLoading: {
        type: Boolean,
        defalut: false
      },
      ulLoadingText: {
        type: String,
        default: '加载中'
      },
//      是否显示空页面
      ulShowEmpty: {
        type: Boolean,
        defalut: false
      },
      ulEmptyText: {
        type: String,
        default: '没有数据'
      },
//      是否显示错误页面
      ulShowErr: {
        type: Boolean,
        defalut: false
      },
      ulErrText: {
        type: String,
        default: '出错了'
      },
//      是否使用加载更多
      ulShowLoadeMore: {
        type: Boolean,
        defalut: false
      },
//      设置加载更多文字
      ulLoadMoreText: {
        type: String,
        default: ''
      },
      ulLoadNoMoreText: {
        type: String,
        default: '没有更多数据'
      },
//      显示加载最新
      ulShowLoadNew: {
        type: Boolean,
        default: false
      },
//      加载最新的文字
      ulLoadNewText: {
        type: String,
        default: ' '
      }
    },
    computed: {
      scrollOption: function () {
        let options = {}
//        if (this.showEmpty) return options
//        是否有下拉加载最新
        if (this.ulShowLoadNew) {
          Object.assign(options, {
            pullDownRefresh: {
              threshold: 90,
              stop: 40,
              txt: this.ulLoadNewText
            }
          })
        }
        if (this.ulShowLoadeMore) {
          Object.assign(options, {
            pullUpLoad: {
              threshold: 0,
              txt: {
                more: this.ulLoadMoreText,
                noMore: this.ulLoadNoMoreText
              }
            }
          })
        }
        if (this.ulShowScrollBar) {
          options.scrollbar = {
            fade: this.ulScrollbar
          }
        }
        options.listenScroll = true
        options.listenBeforeScroll = true
//        options.scrollEvents = ['scroll', 'before-scroll-start', 'scroll-end']
//        options.preventDefault = false
//        options.stopPropagation = false
//        options.preventDefaultException = {tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/}
//        options.pullUpLoad = this.ulShowLoadNew || false
//        options.pullDownRefresh = this.ulShowLoadeMore || false
        return options
      }
    },
    methods: {
//      停止刷新
      stopRefresh: function () {
        console.log('我是结束刷新')
        this.$refs[this.ulHandleKey].forceUpdate()
      },
      getScrollHandle: function () {
        return this.$refs[this.ulHandleKey]
      },
      onScrollEnd: function () {
        console.log('我是结束')
      },
      onStartScroll: function () {
        console.log('我是开始')
      },
      onLoadMore: function () {
        this.$emit('onULoadMore')
      },
      onLoadNew: function () {
        this.$emit('onULoadNew')
      },
      rebuildScroll () {
        Vue.nextTick(() => {
          this.$refs[this.ulHandleKey].destroy()
          this.$refs[this.ulHandleKey].initScroll()
        })
      }
    },
    components: {
      EmptyPlace
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .um-scroll
    .loading, .empty, .error
      height: 100%
      position: absolute
      left: 0
      right: 0
      top: 0
      bottom: 0
    > .cube-scroll-content
      min-height: 100%

</style>



// WEBPACK FOOTER //
// src/common/components/mobile/umScroll/umScroll.vue